import {Component, Prop, Watch} from 'vue-property-decorator';
import { Vue, Options } from 'vue-class-component'
import {CONFIG_ENV} from '@/config';
import { TAlerta } from '@/types/TAlerta';
import {TUser} from "@/types/TUser";
import user from '@/store/user';
import {getModule} from "vuex-module-decorators";
import { ServiceAlerts } from '@/services/ServiceAlerts';
import InvoiceModel from "@/components/InvoiceModel.vue";
import ServiceLogs from '@/services/ServiceLogs';

@Options({
    name: "Alerte",
    components: {InvoiceModel}
})
export default class Alerte extends Vue {
    public loadingAlerts=false;
    public pagination ={rowsPerPage: 100};
    public alerts:Array<TAlerta>=[];
    public showAlert = false;
    public bill_nr='';
    public userStore = getModule(user);
    public columns : any = [];
    public appid = 0;
    
    public visibleColumns =[ 'data', 'descriere', 'action'];

    get user(): TUser {
        return this.userStore.user;
    }

    public getAlertsFromDB(){
        const vueInst=this;
        vueInst.$q.loading.show();
        ServiceAlerts.getAlertsFromDB().then(response=>{
            vueInst.$q.loading.hide();
            vueInst.loadingAlerts=false;
            if(response.status=='success'){
                vueInst.alerts=JSON.parse(JSON.stringify(response.alerts));
            }

        })
    }

    public openAlert(index: number) {
        const alert = this.alerts[index];
        this.showAlert = true;
        if(alert.type == 'i') {
            this.bill_nr = alert.custom_id;
        }
    }

    public splitText(text: string){
        const splittedText = text.split(' ');
        splittedText[2] += "\n";
        return splittedText.join(' ');
    }

    public resendEmail(descriere: string) {
        void ServiceAlerts.sendNotificationEmail(descriere).catch(error => {
            console.error("Error sending email:", error);
        });
    }
    
    public processHtml(html: string): string {
        if (!html) return html;
        return html.replace(/<a(?![^>]*\btarget\b)([^>]*)>/gi, '<a$1 target="_blank" rel="noopener noreferrer">');
    }

    public activated(){
        this.loadingAlerts=true;
        this.columns = [
            { name: 'data', label: this.$t('message.date_and_time'), field: 'data', align: 'left' },
            { name: 'descriere',  label: this.$t('message.description'), field: 'descriere', align: 'left' },
            { name: 'action', label: '', field: 'action', align: 'center' }
        ];
        this.userStore.set_page_transition('fade-in-right');
        if(this.$q.platform.is.mobile) {
            this.userStore.set_showbackbar(true);
            this.userStore.set_title_back_bar(this.$t('message.alerts'));
        }
        this.getAlertsFromDB();
        this.userStore.set_user_alerts_count(0);
        const vueInst = this;
        vueInst.appid = 0;
        ServiceLogs.updateTimeSpentPerPage('alerts', '0', vueInst.appid).then(responce => {
            if(responce.status == 'success'){
                vueInst.appid = responce.appid;
            }
        })
        window.addEventListener('beforeunload', function (event) {
            
            ServiceLogs.updateTimeSpentPerPage('alerts', '0', vueInst.appid);
        });
    }

    deactivated(): void {
        const vueInst=this;
        ServiceLogs.updateTimeSpentPerPage('alerts', '0', vueInst.appid);
    }
}